export const PREFIX = 'mashang.'

const Storage = window.localStorage

/**
 * 获取 JSON 对象
 * @param name
 * @returns {string|*}
 */
export function getItemObject (name) {
  let item = getItem(name)
  return (item) ? JSON.parse(item) : {}
}

/**
 * 获取 JSON 数组
 * @param name
 * @returns {string|*}
 */
export function getItemArray (name) {
  let item = getItem(name)
  return (item) ? JSON.parse(item) : []
}

export function getItem (name) {
  let item = Storage.getItem(PREFIX + name)
  item = (item === 'undefined') ? '' : item
  return item
}

export function saveItem (name, value) {
  return Storage.setItem(PREFIX + name, value)
}

export function saveItemObject (name, value) {
  return Storage.setItem(PREFIX + name, JSON.stringify(value))
}

export function removeItem (name) {
  return Storage.removeItem(PREFIX + name)
}

/**
 * 删除所有
 */
export function removeAll () {
  let keys = []
  let length = Storage.length
  for (let i = 0; i < length; i++) {
    let key = Storage.key(i)
    keys.push(key)
  }

  for (let key of keys) {
    if (key.indexOf(PREFIX) >= 0) {
      Storage.removeItem(key)
    }
  }
}
